import { API } from "."
import { ReadMetricListResponse } from "@/types/metric"

export async function readMetricList() {
  return API.get<ReadMetricListResponse>("/metrics")
}
